<style lang="stylus">
    .buydiscount-modal
        position fixed
        overflow auto
        top 0
        right 0
        bottom 0
        left 0
        z-index 99999
        background rgba(55,55,55,.6)
        display flex
        align-items center
        justify-content center
        .buydiscount-content
            width 297px
            height 303px
            position relative
            .buydiscount-close
                position absolute
                right 18px
                top 18px
                cursor pointer
            .buydiscount-img
                width 100%
                height 100%
                display block
            .buydiscount-btn
                position absolute
                width 190px
                height 48px
                bottom 41px
                left 54px
                z-index 1
                cursor pointer
</style>

<template>
    <transition name="fade">
        <div class="buydiscount-modal" v-if="value" @click.stop>
            <div class="buydiscount-content">
                <div class="buydiscount-close">
                    <img src="@/public/img/buy/close.svg" alt="close" @click="closeModal" />
                </div>
                <img class="buydiscount-img" src="@/public/img/buy/discount.png" alt="discount" />
                <div class="buydiscount-btn" @click="toBuy" />
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
    import { Component, Vue, Watch, Prop } from "vue-property-decorator";
    @Component({})
    export default class BuyDiscount extends Vue {
        @Prop({ required: true, type: Boolean }) value: boolean;
        @Prop({ default: "default", type: String }) type: string;
        @Prop({ default: () => {}, type: Function }) showCallback: Function;
        @Watch("value")
        watchShow() {
            if (this.value) {
                this.$edApi.getCoupon({
                    user_id: this.userInfo.id,
                    code: "NVR7",
                    token: this.userInfo.token,
                });
                this.sensors.track("collectCoupon", {
                    Catalogues: "coupon",
                    type: "NVR7",
                });
            }
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        closeModal() {
            this.$emit("input", false);
            this.sensors.track("strategicPopupClose", {
                popup_type: "coupon_popup",
                close_reason: "click",
            });
        }
        toBuy() {
            this.$emit("input", false);
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "other",
            });
            if (this.type === "slider") {
                this.showCallback(3);
            } else {
                this.$store.commit("toPublicStatus", {
                    type: "showBuyframe",
                    data: true,
                });
            }
            this.sensors.track("strategicPopupClick", {
                popup_type: "coupon_popup",
                button_type: "get_button",
            });
        }
    }
</script>
